const translations = {
  "topbar.InsuranceProducts": "სადაზღვევო პროდუქტები",
  "topbar.OnlineServices": "დისტანციური მომსახურებები",
  // "topbar.OnlineServices": "ანაზღაურება და მიმართვები",
  "topbar.forYou": "შენთვის",
  "topbar.forBusiness": "ბიზნესისთვის",
  "topbar.forForeign": "უცხო ქვეყნის მოქალაქეებისთვის",

  "topbar.NewsAndBlogs": "სიახლეები და ბლოგი",
  "topbar.news": "სიახლეები",
  "topbar.HealthInsurance": "ჯანმრთელობის დაზღვევა",
  "topbar.autoInsurance": "ავტოდაზღვევა",
  "topbar.TravelInsurance": "სამოგზაურო დაზღვევა",
  "topbar.InsuranceAndMore": "დაზღვევა და მეტი",
  "topbar.ForForeignUsers": "უცხო ქვეყნის მოქალაქეებისთვის",
  "topbar.ForeignStudentsInsurance": "უცხოელი სტუდენტების დაზღვევა",
  "topbar.InnerToursInsurance": "შიდა ტურების დაზღვევა",
  "topbar.HealthCorpInsurance": "ჯანმრთელობის კორპორატიული დაზღვევა",
  "topbar.HealthIndividualInsurance":
    "ჯანმრთელობის ინდივიდუალური დაზღვევის სხვა პროდუქტი",
  "topbar.otherProducts": "სხვა პროდუქტები",
  "topbar.ImedilBot": "იმედი L ბოტი",
  "topbar.FamilyReservationToDoc": "ოჯახის ექიმთან ჩაწერა",
  "topbar.InsideTravelInsurance": "ვიზიტორი",
  "main.ProductsAndServices": "პროდუქტები და მომსახურებები",
  "main.Products": "პროდუქტები",
  "main.offers": "შეთავაზებები",
  "main.details": "დეტალურად",
  "main.newsAndBlog": "სიახლეები",
  "main.seeAll": "ნახე სრულად",
  "main.distantCalls": "დისტანციური მიმართვები",
  "main.hospitalGuarantee": "ჰოსპიტალური გარანტია",
  "main.claimForReimbursement": "ანაზღაურების მოთხოვნა",
  "main.moreAbout": "გაიგე მეტი",
  "main.million": "მილიონი",

  "footer.aboutUs": "ჩვენ შესახებ",
  "footer.career": "კარიერა",
  "footer.financialData": "ფინანსური ინფორმაცია",
  "footer.moreAboutInsurance": "გაიგე მეტი დაზღვევაზე",
  "footer.offices": "ოფისები",
  "footer.feedback": "უკუკავშირი",
  "footer.address": "თბილისი, ვაჟა-ფშაველას გამზ. 53ა",
  "footer.ourTeam": "ჩვენი გუნდი",
  "footer.legalInformation": "იურიდიული ინფორმაცია",
  "footer.onlineCenter": "ონლაინ დახმარება",
  "footer.contact": "კონტაქტი",
  "footer.termsAndConditions": "წესები და პირობები",
  "footer.uno": "უნო / უნო+",
  "footer.unoActive": "უნო აქტივი / უნო აქტივი+",
  "footer.unoComfort": "უნო კომფორტი / უნო კომფორტი+",
  "footer.travelInsurance": "სამოგზაურო დაზღვევა",
  "footer.insuranceAndMore": "დაზღვევა და მეტი",
  "footer.newsAndBlogs": "სიახლეები და ბლოგები",
  "footer.news": "სიახლეები",
  "footer.healthAndInsurance": "ჯანმრთელობა და დაზღვევა",
  "footer.company": "კომპანია",
  "footer.contactUs": "დაგვიკავშირდით",
  "footer.healthInsurance": "ჯანმრთელობის დაზღვევა",
  "footer.autoInsurance": "ავტოდაზღვევა",

  "main.aboutUs": "ჩვენ შესახებ",

  "topbar.myPolicy": "ჩემი დაზღვევა",
  "main.callUs": "დაგვირეკეთ",
  "main.messageUs": "მოგვწერეთ",
  "topbar.uno": "უნო / უნო+",
  "topbar.unoActive": "უნო აქტივი / უნო აქტივი+",
  "topbar.unoComfort": "უნო კომფორტი / უნო კომფორტი+",
  "paymentResult.title": "შენი მოთხოვნა დამუშავების პროცესშია",
  "paymentResult.parag": `დასტურის შესახებ ინფორმაციას მიიღებ სმს-ის სახით, 
ხოლო ელექტრონული პოლისი გადმოიგზავნება შენ მიერ მითითებულ ელ-ფოსტაზე`,

  "blogs.today": "დღეს",
};

export default translations;
